import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@aws-amplify/ui-react/styles.css'
import { AmplifyProvider } from "@aws-amplify/ui-react"
import { studioTheme } from './ui-components'
import './App.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AmplifyProvider theme={studioTheme}>
      <App />
    </AmplifyProvider> 
  </React.StrictMode>
);
